
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({name: 'ColorPicker'})
export default class ColorPicker extends Vue {
  @Prop({default: '#ffffff'})
  public value!: string;

  @Prop()
  public label?: string;

  get color() {
    if (!this.value) {
      return '#ffffff';
    }
    return this.value;
  }

  set color(newValue) {
    this.$emit('input', newValue);
  }
}
